export default {
    feedArchive(state) {
        return state.feedArchive;
    },
    pageSize(state) {
        return state.pageSize;
    },
    totalCount(state) {
        return state.totalCount;
    },
    feedId(state) {
        return state.feedId;
    },
    dateFrom(state) {
        return state.dateFrom;
    },
    dateTo(state) {
        return state.dateTo;
    },
    isLoading(state) {
        return state.isLoading;
    },
    hasMore(state) {
        return (state.feedArchive?.length || 0) < state.totalCount;
    }
}
